import React, { Component } from 'react'
import { connect } from 'react-redux'

import Card from 'src/components/cards/Card'
import CustomSelect from 'src/components/inputs/Select/CustomSelect'
import Button from 'src/components/buttons/Button'
import Icon from 'src/components/buttons/IconButton'
import SelectProducts from 'src/components/SelectProducts/SelectProducts'

import { Row, Col, InputGroup, FormControl } from 'react-bootstrap'

import {
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faSearch,
} from '@fortawesome/free-solid-svg-icons'

import { selectCompanyFieldById } from 'src/selectors/company.selector'

import { setInformationOrder } from 'src/actions/orders.actions'
import {
  actionTypes,
  getExistenceSingleWarehouseWithPriceProducts,
  getInventory,
  setInventoryList,
  setOrigin,
} from 'src/actions/warehouse.actions'
import {
  selectAllWarehousesForSelect,
  selectOrigin,
  selectWarehouseInventory,
} from 'src/selectors/warehouse.selector'

import { selectGetSingleOrder } from 'src/selectors/orders.selector'

import {
  selectCurrentCompany,
  selectCurrentUser,
  selectCurrentModule,
} from 'src/selectors/user.selector'

import { loadingSelector } from 'src/selectors/loading.selector'
import { selectContractedProducts } from 'src/selectors/contracts.selector'
import { getProductContractedByWarehouse } from 'src/selectors/products.selector'

import { isAllowed } from 'src/selectors/modules.selector'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { selectCompanyField } from 'src/selectors/company.selector'
import Money from 'src/components/Money/Money'

class OrderSelectProducts extends Component {
  state = {
    modal: {
      value: false,
      item: {},
      subProduct: {},
      maxDiscount: 0,
      baseQuantity: 0,
    },
    maxDiscount: 0,
    alert: { show: false, title: 'default' },
    search: '',
    withoutcontract: false,
    inactive: false,
    withoutExistence: false,
    consigned: false,
    own: true,
  }

  componentDidMount() {
    const { isAllowed } = this.props
    this.setState({ withoutExistence: isAllowed([1111, 2811]) })
  }

  seeOptions = (checked, index) => {
    const { setInventoryList, inventory } = this.props
    inventory.map(i => {
      if (i.productId === index) {
        i.checked = checked
      }
    })
    setInventoryList(inventory)
  }

  changeQuantity = (value, index) => {
    const { setInventoryList, inventory } = this.props

    let item = inventory.find(i => i.productId === index)

    if (!item) return
    let quantity = parseInt(value)

    if (quantity < 0) quantity = 0
    if (item.productExistence <= 0) {
    } else if (quantity > item.productExistence) quantity = item.productExistence

    let nowQuantity = (item.transformationFactor || 1) * quantity
    if (item.subProductId)
      nowQuantity +=
        (item.subProductData.transformationFactor || 1) * (item.sQuantity || 0)

    item.realQuantity = nowQuantity / (item.transformationFactor || 1)
    item.quantity = quantity

    const maxDiscount = this.getMaxDiscount(
      nowQuantity / (item.transformationFactor || 1),
      item,
    )
    if (item.discount > maxDiscount) item.discount = maxDiscount
    item.maxDiscount = maxDiscount
    item.subTotal = this.getSubTotal(item)

    inventory.map(i => {
      if (i.productId === index) {
        i = item
      }
    })
    setInventoryList(inventory)
  }

  changeSQuantity = (value, index) => {
    const { setInventoryList, inventory } = this.props

    let item = inventory.find(i => i.productId === index)

    if (!item) return

    let quantity = parseInt(value)
    const maxQuantity = item.saleRecipe ? 1000000 : item.subProductValue || 0

    if (quantity > maxQuantity) quantity = maxQuantity
    if (quantity < 0) quantity = 0

    let nowQuantity = (item.subProductData.transformationFactor || 1) * quantity

    if (item.quantity)
      nowQuantity += (item.transformationFactor || 1) * (item.quantity || 0)

    item.realQuantity = nowQuantity / (item.transformationFactor || 1)
    item.sQuantity = quantity

    const maxDiscount = this.getMaxDiscount(item.realQuantity, item)
    if (item.discount > maxDiscount) item.discount = maxDiscount
    item.maxDiscount = maxDiscount
    item.subTotal = this.getSubTotal(item)

    inventory.map(i => {
      if (i.productId === index) {
        i = item
      }
    })
    setInventoryList(inventory)
  }

  changeDiscount = (value, index) => {
    const { setInventoryList, inventory } = this.props

    let item = inventory.find(i => i.productId === index)

    if (!isNaN(value)) {
      let discount = value
      if (!discount || discount < 0) discount = 0
      else if (discount > Number.parseFloat(item.maxDiscount)) discount = item.maxDiscount
      item.discount = discount
      item.subTotal = this.getSubTotal(item)

      inventory.map(i => {
        if (i.productId === index) {
          i = item
        }
      })
      setInventoryList(inventory)
    }
  }

  getMaxDiscount = (quantity, item) => {
    const { discountLimit, maxDiscount } = this.props
    let max

    if (item.saleRecipe) {
      max = this.getSubTotal(item, true)
    } else {
      if (isNaN(quantity)) quantity = 0
      let discount = 0
      let price = item.productPrice || item.price
      if (item.prices && discountLimit) {
        item.prices.filter(p => quantity >= p.minimum).map(p => (discount = p.price))
        //if (item.discountLimit) discount -= (discount * 0.05);
      } else if (!discountLimit) discount = price
      if (item.discountLimited) discount = item.discountLimitedNumber
      max = parseFloat(discount) * parseFloat(quantity)
    }
    return Number.parseFloat((Number.parseFloat(maxDiscount) * max) / 100).toFixed(2)
  }

  changeCommentary = (commentary, index) => {
    const { setInventoryList, inventory } = this.props
    let item = inventory.find(i => i.productId === index)
    item.commentary = commentary
    inventory.map(i => {
      if (i.productId === index) {
        i = item
      }
    })
    setInventoryList(inventory)
  }

  filterProducts = item => {
    const { search } = this.state

    let see = false
    Object.keys(item).map(i => {
      const textValue = JSON.stringify(item[i])
      if (textValue.toUpperCase().indexOf(search.toUpperCase()) > -1) {
        see = true
      }
    })
    if (this.props.match.params.linked === 'true') return see ? item.contracted : see
    return search ? see : true
  }

  getSubTotal = (item, ignore) => {
    let subTotal = 0
    let price = item.productPrice || item.price
    if (item.quantity >= 0) subTotal += (item.quantity || 0) * price
    if (item.sQuantity >= 0 && item.subProductData) {
      subTotal += (item.sQuantity || 0) * this.getSubPrice(item)

      /*if (item.useFactor) {
                subTotal += (item.sQuantity || 0) * (item.productPrice / (item.subProductValue || 1));
            } else
                subTotal += (item.sQuantity || 0) * item.subProductData.price;
            */
    }
    if (ignore) return subTotal
    else return subTotal - (item.discount || 0)
  }

  getTotal = () => {
    const { inventory } = this.props
    let total = 0
    inventory
      .filter(i => i.checked)
      .map(i => {
        total += i.subTotal || 0
      })
    return total
  }

  getDiscounts = () => {
    const { inventory } = this.props
    let total = 0
    inventory
      .filter(i => i.checked)
      .map(i => {
        total += Number.parseFloat(i.discount || 0)
      })
    return total
  }

  handleCheckBoxChange = event => {
    const { name, checked } = event.target
    this.setState({ [name]: checked })
  }

  filter = item => {
    let { withoutcontract, inactive, withoutExistence, consigned, own } = this.state
    const { module } = this.props

    if (module === 2000) {
      withoutcontract = true
      item.prices = []
    }

    return (
      (item.productActive || (inactive && !item.productActive)) &&
      (item.contract || (withoutcontract && !item.contract)) &&
      (item.productExistence > 0 || (withoutExistence && item.productExistence <= 0)) &&
      ((consigned && item.origin === 1) || (own && item.origin !== 1))
    )
  }

  getSubPrice = item => {
    const { saleRecipe, productPrice, subProductValue, subProductData } = item
    let price = 0
    if (subProductData) {
      const useFactor = subProductData.useFactor
      if (saleRecipe == null)
        price = useFactor ? productPrice / (subProductValue || 1) : subProductData.price
      else
        price = useFactor
          ? (subProductData.subProductValue / subProductValue) * productPrice
          : subProductData.price
    }

    return price
  }

  getSubValue = item => {
    const { subProductData } = item
    return subProductData ? subProductData.id : null
  }

  render() {
    const {
      loadingI,
      currentCompany,
      inventory,
      allWarehouses,
      order,
      getInventoryWithPrices,
      match,
      contractedProducts,
      blockDiscount,
    } = this.props
    const { warehouse } = order

    const { search, withoutcontract, inactive, withoutExistence, consigned, own } =
      this.state
    const { params } = match

    let items
    if (this.props.match.params.linked === 'true')
      items = this.props.products(inventory, contractedProducts)
    else items = inventory.filter(this.filter)
    return (
      <div>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card>
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomSelect
                    loading={loadingI}
                    label={'Bodegas'}
                    options={allWarehouses.filter(
                      w =>
                        w.attendant == this.props.user.id ||
                        w.attendantsIds.some(id => id === this.props.user.id),
                    )}
                    value={warehouse}
                    onChange={data => {
                      this.props.setInfo({
                        ...order,
                        warehouse: data,
                        products: [],
                      })
                      getInventoryWithPrices(
                        data.value,
                        order.client,
                        currentCompany,
                        false,
                        false,
                      )
                    }}
                    required
                  />
                </Col>
                <Col>
                  <div className={'column'}>
                    <br />
                    <Row>
                      <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        <Card>
                          <div className={'justify-center column'}>
                            <span>Total</span>
                            <Money component="h4">
                              <strong>{this.getTotal()}</strong>
                            </Money>
                          </div>
                        </Card>
                      </Col>
                      <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                        <Card>
                          <div className={'justify-center column'}>
                            <span>Descuentos</span>
                            <Money component="h4">
                              <strong>{this.getDiscounts()}</strong>
                            </Money>
                          </div>
                        </Card>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={4} lg={4} md={4} sm={4} xs={6}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'inactive'}
                            checked={inactive}
                            onChange={this.handleCheckBoxChange}
                          />
                          Inactivas ({inventory.filter(i => !i.productActive).length})
                        </label>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={4} xs={6}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'withoutcontract'}
                            checked={withoutcontract}
                            onChange={this.handleCheckBoxChange}
                          />
                          Sin contrato ({inventory.filter(i => !i.contract).length})
                        </label>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'withoutExistence'}
                            checked={withoutExistence}
                            onChange={this.handleCheckBoxChange}
                          />{' '}
                          Sin existencia (
                          {inventory.filter(i => i.productExistence <= 0).length})
                        </label>
                      </Col>
                    </Row>
                    <hr />
                    <Row className={'container-buttons'}>
                      <Col>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'consigned'}
                            checked={consigned}
                            onChange={this.handleCheckBoxChange}
                          />{' '}
                          Producto consignado (
                          {inventory.filter(i => i.origin === 1).length})
                        </label>
                      </Col>
                      <Col>
                        <label className={'checkbox-label'}>
                          <input
                            type={'checkbox'}
                            name={'own'}
                            checked={own}
                            onChange={this.handleCheckBoxChange}
                          />{' '}
                          Producto de la empresa (
                          {inventory.filter(i => i.origin != 1).length})
                        </label>
                      </Col>
                    </Row>
                    <InputGroup className={'mb-3'}>
                      <FormControl
                        placeholder={'Buscar por Nombre/ descripción/ código/ productora'}
                        value={search}
                        onChange={e => this.setState({ search: e.target.value })}
                      />
                      <InputGroup.Text>
                        <Icon tooltip={'Buscar'} icon={faSearch} />
                      </InputGroup.Text>
                    </InputGroup>

                    {inventory.length > 0 && items.length <= 0 && (
                      <div className={'center'}>
                        <h4>No hay productos disponibles para los filtros aplicados.</h4>
                      </div>
                    )}
                    <Row>
                      {loadingI && (
                        <Col>
                          <ProgressBar style={{ marginTop: 5 }} animated now={100} />
                        </Col>
                      )}
                    </Row>
                    <Row className={'product_list'}>
                      {items.filter(this.filterProducts).map((i, index) => (
                        <Col xl={3} lg={3} md={6} sm={6} xs={12} key={index}>
                          <SelectProducts
                            index={i.productId}
                            sku={i.productCode}
                            title={i.productName}
                            description={i.productDescription}
                            existence={i.productExistence}
                            price={i.productPrice}
                            discount={i.discount}
                            seeDiscount={
                              !(blockDiscount && blockDiscount.value === 'true')
                            }
                            maxDiscount={i.maxDiscount}
                            subtotal={i.subTotal}
                            checked={i.checked}
                            quantity={i.quantity}
                            sQuantity={i.sQuantity}
                            sValue={this.getSubValue(i)}
                            sTitle={
                              i.subProductData
                                ? `${i.subProductData.code} ${i.subProductData.name}`
                                : ''
                            }
                            sPrice={this.getSubPrice(i)}
                            seeOptions={this.seeOptions}
                            changeQuantity={this.changeQuantity}
                            changeSQuantity={this.changeSQuantity}
                            changeDiscount={this.changeDiscount}
                            error={i.error}
                            disabled={i.disabled}
                            ribbon={
                              i.productCompanyId !== currentCompany ? 'KOLO' : 'Propio'
                            }
                            ribbonClass={
                              i.productCompanyId !== currentCompany
                                ? 'kolo_pink'
                                : 'kolo_blue'
                            }
                            warehouseId={warehouse && warehouse.value}
                            seeCommentary
                            commentary={i.commentary}
                            onChangeCommentary={this.changeCommentary}
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <hr />
        <Row className={'container-buttons'}>
          <Button
            color={'secondary'}
            onClick={() => this.props.jumpToStep(0)}
            icon={faLongArrowAltLeft}>
            Regresar
          </Button>
          <Button
            disabled={this.getTotal() <= 0 || loadingI}
            color={'primary'}
            onClick={() => {
              if (params.id && params.sale) this.props.jumpToStep(1)
              else this.props.jumpToStep(2)
            }}
            icon={faLongArrowAltRight}>
            Siguiente
          </Button>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  allWarehouses: selectAllWarehousesForSelect(state),
  order: selectGetSingleOrder(state),
  inventory: selectWarehouseInventory(state),
  currentCompany: selectCurrentCompany(state),
  loadingI: loadingSelector([actionTypes.GET_INVENTORY_WITH_PRICE])(state),
  user: selectCurrentUser(state),
  module: selectCurrentModule(state),
  origin: selectOrigin(state),
  contractedProducts: selectContractedProducts(state),
  products: (inventory, contracted) =>
    getProductContractedByWarehouse(inventory, contracted),
  isAllowed: permissions => isAllowed(state, permissions),
  blockDiscount: selectCompanyField(state),
  maxDiscount: selectCompanyFieldById(state, 89),
})
const mapDispatchToProps = dispatch => ({
  setInfo: order => dispatch(setInformationOrder(order)),
  getInventoryWithPrices: (id, client, currentCompany, includeNoExistence, reserve) =>
    dispatch(
      getExistenceSingleWarehouseWithPriceProducts(
        id,
        client,
        currentCompany,
        includeNoExistence,
        reserve,
        1,
      ),
    ),
  getInventory: (id, includeNoExistence) =>
    dispatch(getInventory(id, includeNoExistence)),
  setInventoryList: list => dispatch(setInventoryList(list)),
  setOrigin: origin => dispatch(setOrigin(origin)),
})
export default connect(mapStateToProps, mapDispatchToProps)(OrderSelectProducts)
